module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="selection_wrapper">\n	<label>' +
((__t = (label)) == null ? '' : __t) +
'</label>\n	<select class="dropdown_list" id="' +
((__t = (label)) == null ? '' : __t) +
'" field="' +
((__t = (fieldName)) == null ? '' : __t) +
'"></select>\n</div>';

}
return __p
}